import { render, staticRenderFns } from "./ConfigurazioneMagazzinoMagazziniListPage.vue?vue&type=template&id=7b06e745"
import script from "./ConfigurazioneMagazzinoMagazziniListPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneMagazzinoMagazziniListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports